import * as utils from '@utils/form';
import { IMAGE_SIZE } from '@api/media/constants';

export const FORM_FIELD = {
  DESKTOP_BANNER: {
    name: 'desktopBanner',
    label: 'Desktop banner:',
    size: IMAGE_SIZE['2000x240'],
    serialize: utils.imageSerialize,
    deserialize: utils.imageDeserialize,
    deserializeError: utils.deserializeErrorRelatedField,
    rules: [{ required: true, message: 'Desktop banner is required' }],
  },
  MOBILE_BANNER: {
    name: 'mobileBanner',
    label: 'Mobile banner:',
    size: IMAGE_SIZE['700x300'],
    serialize: utils.imageSerialize,
    deserialize: utils.imageDeserialize,
    deserializeError: utils.deserializeErrorRelatedField,
    rules: [{ required: true, message: 'Mobile banner is required' }],
  },
  BANNER_URL: {
    name: 'bannerUrl',
    label: 'Banner URL',
    placeholder: 'Enter banner URL',
    rules: [
      { type: 'url', message: "Doesn't look like a valid URL" },
      { required: true, message: 'URL is required' },
    ],
  },
  LIVE: {
    name: 'isLive',
    label: 'Set Live',
  },
  ID: {
    name: 'id',
  },
};

export const INITIAL_VALUES = {
  [FORM_FIELD.LIVE.name]: false,
};
